class AddToCartButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", () => {
      // Retrieve the variant ID from the data attribute
      const productVariantId = this.dataset.variantId;

      // Prepare the formData object
      const formData = {
        items: [
          {
            id: productVariantId, // The main variant ID
            quantity: 1, // Default quantity
          },
        ],
      };

      // Send POST request to add the product to the cart
      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (!response.ok) {
            if (response.status === 422) {
              let errorElement = document.querySelector("#error-message");
              errorElement.textContent = "This product is out of stock.";
              errorElement.dataset.active = true;
              setTimeout(() => {
                errorElement.dataset.active = false;
              }, 2000);
            }
            throw new Error("Failed to add product to cart");
          }
          return response.json();
        })
        .then((cartItem) => {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "add-to-cart",
          });
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);
          //alert("There was an issue adding the product to the cart.");
        });
    });
  }
}

customElements.define("add-to-cart", AddToCartButton);
